import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { useHistory } from 'react-router';
import TW_log from '../machineUI/NaviBar/icons/travel-wifi-logo.png';
import AmericanExpress from '../Icons/payment/AmericanExpress.png';
import ApplePay from '../Icons/payment/ApplePay.png';
import DinersClub from '../Icons/payment/DinersClub.png';
import Discover from '../Icons/payment/Discover.png';
import GPay from '../Icons/payment/GPay.png';
import JCB from '../Icons/payment/JCB.png';
import Mastercard from '../Icons/payment/Mastercard.png';
import Visa from '../Icons/payment/Visa.png';
import Cookies from 'js-cookie';
import localRequest from '../services/LocalServer/localRequest';

export default function PaymentPrompt(props) {
  const [one, setone] = useState(true);
  const [allowback, setallowback] = useState(true);
  const isLocal = localStorage.getItem('ISLOCAL') === 'TRUE';
  let history = useHistory();
  const { t } = useTranslation();
  const machineID = props.id;

  const [message, setMessage] = useState(t('Insert or swipe your card.'));

  let separateItem = JSON.parse(localStorage.getItem('SeparateItem'));
  const mobile_pay = localStorage.getItem('MOBILE_PAY') === 'TRUE';
  let paymentMethod = 2;
  separateItem = separateItem.filter((e) => e.prodType === 'prod');

  const AE_PAY = localStorage.getItem('AE_PAY') === 'TRUE';
  const DC_PAY = localStorage.getItem('DC_PAY') === 'TRUE';
  const DIS_PAY = localStorage.getItem('DIS_PAY') === 'TRUE';
  const JCB_PAY = localStorage.getItem('JCB_PAY') === 'TRUE';

  if (mobile_pay) {
    paymentMethod++;
    paymentMethod++;
  }
  if (AE_PAY) {
    paymentMethod++;
  }
  if (DC_PAY) {
    paymentMethod++;
  }
  if (DIS_PAY) {
    paymentMethod++;
  }
  if (JCB_PAY) {
    paymentMethod++;
  }

  const prods = separateItem.map((prod, i) => {
    // console.log(prod);
    // const url = `${process.env.REACT_APP_SERVER_API}/pictures/${prod.picture}/${prod.referTo}`;
    const url = isLocal
      ? `${process.env.REACT_APP_LOCAL_API}/pictures/products/${prod.picture}`
      : `${process.env.REACT_APP_SERVER_API}/pictures/${prod.picture}/${prod.referTo}`;
    return (
      <div className="payment-product-card" key={i}>
        <img className="card-img" src={url} alt=""></img>
        <div className="payment-card-text">{prod.product_name}</div>
      </div>
    );
  });

  const cancelButton = async () => {
    if (one && allowback) {
      await localRequest({
        method: 'post',
        url: `${process.env.REACT_APP_LOCAL_API}/paymentUpdate`,
        data: {
          status: 'CANCEL',
        },
      }).then((res) => {
        setone(false);
        setTimeout(() => {
          history.goBack();
        }, 3000);
      });
    }
  };

  useEffect(() => {
    // payment status request
    var interval = setInterval(() => fetchAPI(), 500);
    // out of order request
    // var outInterval = setInterval(() => outOfOrderRequest(outInterval, machineID), 2000);

    async function fetchAPI() {
      // console.log('featchAPI');
      await axios
        .get(`${process.env.REACT_APP_LOCAL_API}/paymentStatus`, {
          headers: {
            'X-CompanyID': 'magex',
            'X-Token': process.env.REACT_APP_X_TOKEN,
          },
        })
        .then(async (status) => {
          if (status.data.status_message) {
            setMessage(status.data.status_message);
          }
          if (status.data.status && status.data.status !== '') {
            setallowback(false);
          }
          if (status.data.status === 'SUCCESS') {
            // clearInterval(outInterval);
            clearInterval(interval);
            localStorage.setItem('payment_type', 'Credit');
            history.push(`/machineUI/product-dispense/${machineID}`);
          } else if (status.data.status === 'PAYMENTERROR') {
            clearInterval(interval);
            setMessage(t('Payment error, back to previous page'));
            setTimeout(() => {
              history.goBack();
            }, 3000);
          }
          const dataDate = new Date(status.data.date);
          const nowDate = new Date();

          const dif = nowDate.getTime() - dataDate.getTime();
          // console.log(dif);
          if (dif < 30000) {
            props.setIdle(dif);
          }
        });
    }

    return () => {
      clearInterval(interval);
      // clearInterval(outInterval);
    };

    // history.push(`/machineUI/product-dispense/${machineID}`);
  }, []);

  return (
    <div className="payment-container">
      <div className="payment-container-div">
        <img className="payment-logo-img" src={TW_log}></img>
        <div className="payment-products-container">{prods}</div>
        <div className="payment-line"></div>
        <div className="payment-title">{message}</div>
        {paymentMethod > 8 ? (
          <div className="payment-list2">
            <div className="payment-first-div">
              <img className="payment-visa-icon2" src={Visa} alt="" />
            </div>
            <div className="payment-first-div">
              <img className="payment-visa-icon2" src={Mastercard} alt="" />
            </div>
            {mobile_pay && (
              <div className="payment-first-div">
                <img className="payment-visa-icon2" src={GPay} alt="" />
              </div>
            )}
            {mobile_pay && (
              <div className="payment-first-div">
                <img className="payment-visa-icon2" src={ApplePay} alt="" />
              </div>
            )}
            {AE_PAY && (
              <div className="payment-first-div">
                <img className="payment-visa-icon2" src={AmericanExpress} alt="" />
              </div>
            )}
            {DC_PAY && (
              <div className="payment-first-div">
                <img className="payment-visa-icon2" src={DinersClub} alt="" />
              </div>
            )}
            {DIS_PAY && (
              <div className="payment-first-div">
                <img className="payment-visa-icon2" src={Discover} alt="" />
              </div>
            )}
            {JCB_PAY && (
              <div className="payment-first-div">
                <img className="payment-visa-icon2" src={JCB} alt="" />
              </div>
            )}
          </div>
        ) : (
          <div className="payment-list">
            <div className="payment-first-div">
              <img className="payment-visa-icon" src={Visa} alt="" />
            </div>
            <div className="payment-first-div">
              <img className="payment-visa-icon" src={Mastercard} alt="" />
            </div>
            {mobile_pay && (
              <div className="payment-first-div">
                <img className="payment-visa-icon" src={GPay} alt="" />
              </div>
            )}
            {mobile_pay && (
              <div className="payment-first-div">
                <img className="payment-visa-icon" src={ApplePay} alt="" />
              </div>
            )}
            {AE_PAY && (
              <div className="payment-first-div">
                <img className="payment-visa-icon" src={AmericanExpress} alt="" />
              </div>
            )}
            {DC_PAY && (
              <div className="payment-first-div">
                <img className="payment-visa-icon" src={DinersClub} alt="" />
              </div>
            )}
            {DIS_PAY && (
              <div className="payment-first-div">
                <img className="payment-visa-icon" src={Discover} alt="" />
              </div>
            )}
            {JCB_PAY && (
              <div className="payment-first-div">
                <img className="payment-visa-icon" src={JCB} alt="" />
              </div>
            )}
          </div>
        )}
        {allowback && (
          <div className="view-more-button payment-cancel-button" onClick={cancelButton}>
            {t(`CANCEL`)}
          </div>
        )}
      </div>
    </div>
  );
}
